module.exports = "<audio [src]=\"url\" #player controls></audio>\r\n"